export default "__VITE_ASSET__DP2kVWfd__"